import React, { useEffect, useState } from 'react';
import './MeritSection.css'; // CSSファイル

import meritImage01 from '../assets/images/top/merit-image-01.png';
import meritImage02 from '../assets/images/top/merit-image-02.png';
import meritImage03 from '../assets/images/top/merit-image-03.png';
import meritImage04 from '../assets/images/top/merit-image-04.png';
import meritImage05 from '../assets/images/top/merit-image-05.png';
import meritImage06 from '../assets/images/top/merit-image-06.png';
import meritImage07 from '../assets/images/top/merit-image-07.png';
import meritImage08 from '../assets/images/top/merit-image-11.png';
import meritImage09 from '../assets/images/top/merit-image-13.png';
import meritImage10 from '../assets/images/top/merit-image-14.png';
import meritImage11 from '../assets/images/top/merit-image-15.png';
import smallImage01 from '../assets/images/top/small-icon-01.png'; // 小さな画像1
import smallImage02 from '../assets/images/top/small-icon-02.png'; // 小さな画像1
import smallImage03 from '../assets/images/top/small-icon-03.png'; // 小さな画像1
import smallImage04 from '../assets/images/top/small-icon-04.png'; // 小さな画像1
import smallImage05 from '../assets/images/top/small-icon-05.png'; // 小さな画像1

const MeritSection = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [deviceType, setDeviceType] = useState('desktop'); // 'mobile', 'tablet', 'desktop'のいずれか

  useEffect(() => {
    // 画面の幅をチェックし、デバイスタイプを設定
    const checkDeviceType = () => {
      if (window.innerWidth <= 480) {
        setDeviceType('mobile'); // スマホの場合
      } else if (window.innerWidth <= 768) {
        setDeviceType('tablet'); // iPad Miniの場合
      } else {
        setDeviceType('desktop'); // PCの場合
      }
    };

    // 初期のチェック
    checkDeviceType();

    // ウィンドウのリサイズ時にも再チェック
    window.addEventListener('resize', checkDeviceType);

    const handleScroll = () => {
      const imageContainer = document.querySelector('.image-container');
      const smallImages = document.querySelectorAll('.small-image');
      const triggerHeight = window.innerHeight / (deviceType === 'mobile' ? 1.5 : 1.8); // スマホの場合、少し早くトリガー
      const containerTop = imageContainer.getBoundingClientRect().top;
      const position = window.scrollY;
      setScrollPosition(position);
      console.log('Scroll Position:', position, 'Device Type:', deviceType);

      if (containerTop < triggerHeight) {
        smallImages.forEach((img, index) => {
          img.classList.add('fly-out');
          img.style.animationDelay = `${index * 0.2}s`;
          img.style.transition = `${index * 0.2}s`;
        });
      } else {
        smallImages.forEach((img) => {
          img.classList.remove('fly-out');
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkDeviceType);
    };
  }, [deviceType]);

  const getMerit2Image = () => {
    if (deviceType === 'mobile') {
      if (scrollPosition < 3650) {
        return meritImage02;
      } else if (scrollPosition >= 3650 && scrollPosition < 3900) {
        return meritImage03;
      } else {
        return meritImage04;
      }
    } else if (deviceType === 'tablet') {
      if (scrollPosition < 3700) {
        return meritImage02;
      } else if (scrollPosition >= 3700 && scrollPosition < 3900) {
        return meritImage03;
      } else {
        return meritImage04;
      }
    } else {
      // デスクトップの場合
      if (scrollPosition < 2350) {
        return meritImage02;
      } else if (scrollPosition >= 2350 && scrollPosition < 2500) {
        return meritImage03;
      } else {
        return meritImage04;
      }
    }
  };

  const getMerit3Image = () => {
    if (deviceType === 'mobile') {
      if (scrollPosition < 5350) {
        return meritImage05;
      } else if (scrollPosition >= 5350 && scrollPosition < 5550) {
        return meritImage06;
      } else {
        return meritImage07;
      }
    } else if (deviceType === 'tablet') {
      if (scrollPosition < 5500) {
        return meritImage05;
      } else if (scrollPosition >= 5500 && scrollPosition < 5650) {
        return meritImage06;
      } else {
        return meritImage07;
      }
    } else {
      // デスクトップの場合
      if (scrollPosition < 3450) {
        return meritImage05;
      } else if (scrollPosition >= 3450 && scrollPosition < 3650) {
        return meritImage06;
      } else {
        return meritImage07;
      }
    }
  };

  const getMerit4Image = () => {
    return meritImage08;
  };

  const getMerit5Image = () => {
    if (deviceType === 'mobile') {
      if (scrollPosition < 6400) {
        return meritImage09;
      } else if (scrollPosition >= 6400 && scrollPosition < 6600) {
        return meritImage10;
      } else {
        return meritImage11;
      }
    } else if (deviceType === 'tablet') {
      if (scrollPosition < 6500) {
        return meritImage09;
      } else if (scrollPosition >= 6500 && scrollPosition < 6600) {
        return meritImage10;
      } else {
        return meritImage11;
      }
    } else {
      // デスクトップの場合
      if (scrollPosition < 4200) {
        return meritImage09;
      } else if (scrollPosition >= 4200 && scrollPosition < 4300) {
        return meritImage10;
      } else {
        return meritImage11;
      }
    }
  };


  const smallImages = [smallImage01, smallImage02, smallImage03, smallImage04, smallImage05];

  return (
    <div className='merit-section'>
      <h2 className="merit-title">Merit</h2>
      <p>当校独自のメリットが数多く存在しています。</p>

      <div className="merit-item">
        <div className="content-left">
          <div className='inner-content'>
            <div className="number">
              1
            </div>
            <h3 className="text">
              実践的なスキル
            </h3>
            <div>
              <h4>
                プログラミングの書き方を覚えただけでは、何もできません！<br />
                実務実習をこなすことで、以下のノウハウを得ることができます。<br />
              </h4>
              <ul>
                <li>開発環境の構築</li>
                <li>Web上へ公開する方法</li>
                <li>顧客とのやりとり</li>
                <li>チーム開発の経験</li>
                <li>プロジェクトマネジメント</li>
                <li>実務経験</li>
                <li>見せられる成果物の作成</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="image image-container">
          <img src={ meritImage01 } alt="メリットの画像" />
          {/* 小さい画像をまとめるコンテナ */}
          <div className="small-images-container">
            {smallImages.map((imageSrc, index) => (
              <img src={imageSrc} alt="小さな画像" className="small-image" />
            ))}
          </div>
        </div>
      </div>

      <div className="merit-item">
        <div className="content-left">
          <div className='inner-content'>
            <div className="number">
              2
            </div>
            <h3 className="text">
              自由な働き方
            </h3>
            <div>
              <h4>
                就職、起業、フリーランスなど、働き方の選択肢が広がります。<br />
                学校独自のサポートで、安定的な働き方を実現します。<br />
              </h4>
              <ul>
                <li>就職</li>
                <li>起業</li>
                <li>フリーランス</li>
                <li>複業・兼業</li>
                <li>リモートワーク</li>
                <li>ノマドワーク</li>
                <li>半農半ITプログラム</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="image image-container">
          <img src={ getMerit2Image() } alt="メリットの画像" />
        </div>
      </div>

      <div className="merit-item">
        <div className="content-left">
          <div className='inner-content'>
            <div className="number">
              3
            </div>
            <h3 className="text">
              卒業後のサポート
            </h3>
            <div>
              <h4>
                卒業後も継続的にコミュニティへの参加が可能です。<br />
                関係人口が多くなるほど、仕事の授受や地域の活性化が促進されます。<br />
              </h4>
              <ul>
                <li>就職サポート</li>
                <li>仕事が受け取れる</li>
                <li>NFTスキル証明書</li>
                <li>コワーキングスペースの利用</li>
                <li>メタバース空間での共同作業場所</li>
                <li>在校生、卒業生、講師との交流</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="image image-container">
          <img src={ getMerit4Image() } alt="メリットの画像" />
        </div>
      </div>

      <div className="merit-item">
        <div className="content-left">
          <div className='inner-content'>
            <div className="number">
              4
            </div>
            <h3 className="text">
              メタバース英会話
            </h3>
            <div>
            <h4>
                英会話を勉強することで、世界が広がります。<br />
                世界で活躍できるようになります。＊必須ではありません。<br />
              </h4>
              <ul>
                <li>専属Buddyと英会話</li>
                <li>24時間365日 AIとレッスン</li>
                <li>全世界の英語学習者と会話</li>
                <li>学校専用メタバース空間</li>
                <li>マッチングイベント</li>
                <li>ロールプレイング</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="image image-container">
          <img src={ getMerit3Image() } alt="メリットの画像" />
        </div>
      </div>

      <div className="merit-item">
        <div className="content-left">
          <div className='inner-content'>
            <div className="number">
              5
            </div>
            <h3 className="text">
              その他・オプション
            </h3>
            <div>
              <h4>
                独学や他の学校では得られないメリットがたくさんあります。<br />
                今までにない自分にレベルアップできます。<br />
              </h4>
              <ul>
                <li>起業支援プログラム</li>
                <li>メタバースキャンパスライフ</li>
                <li>自治体連携</li>
                {/* <li>紹介プログラム</li> */}
                <li>学費補助</li>
                <li>地方創生活動</li>
                <li>キャリアコンサルティング</li>
                <li>メンタルサポート</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="image image-container">
          <img src={ getMerit5Image() } alt="メリットの画像" />
        </div>
      </div>

    </div>
  );
};

export default MeritSection;